import { createContext, Dispatch } from 'react';
import { ActionTypes, SettingsState } from './types';
import { PwaPromptTools } from './hooks/useInstallPwaPrompt';

export type SettingsContextType = SettingsState & {
  setSettings: Dispatch<ActionTypes>;
  pwa: PwaPromptTools;
};

/** Контекст для хранения различных переменных, ради которых не хочется создавать
 * индивидуальный контекст
 */
export const SettingsContext = createContext<SettingsContextType>({} as SettingsContextType);
